<template>
    <div>
        <b-row>
            <b-col>
                <h5 class="text-secondary">Hype</h5>
            </b-col>
        </b-row>

        <b-form-tags v-model="noteTags" size="sm" placeholder="" separator="," no-outer-focus>
            <template v-slot="{ tags, inputAttrs, inputHandlers, removeTag }">
                <b-input-group size="sm">
                    <input v-bind="inputAttrs" v-on="inputHandlers" placeholder="Enter to add" class="form-control" aria-controls="my-custom-tags-list">
                    <b-input-group-append v-if="defaultHype && defaultHype.length">
                        <b-button size="sm" :id="'defaultHype'" variant="outline-primary" tabindex="-1"
                            @click="useDefaultHype()">
                            <b-icon-forward></b-icon-forward>
                        </b-button>

                        <b-tooltip :target="'defaultHype'" triggers="hover">
                            {{ defaultHype }}
                        </b-tooltip>
                    </b-input-group-append>
                </b-input-group>
                <ul class="list-unstyled d-inline-flex flex-wrap mb-0">
                    <b-card v-for="tag in tags" :key="tag" size="sm" class="mt-1 mr-1" body-class="py-0 pr-2">
                        <drag :transfer-data="tag" drop-effect="copy" effect-allowed="copy">
                            <span>{{ tag }}</span>

                            <b-button variant="link" class="pt-1 pb-1 text-secondary" @click="removeTag(tag)"
                                tabindex="-1">
                                <b-icon-x-square></b-icon-x-square>
                            </b-button>
                        </drag>
                    </b-card>
                </ul>



            </template>
        </b-form-tags>
    </div>
</template>

<script>
import arrayMixin from "../../mixins/array";
import genreList from "../../assets/genreList";

export default {
    name: "Notes",
    props: ['notes', 'noteDropped'],
    mixins: [arrayMixin, genreList],
    created() {
        this.clone(this.notes);
        this.noteTags = this.filteredNotes;
        this.defaultHype = localStorage.getItem('inventoryHype') || '';
    },
    data() {
        return {
            defaultHype: '',
            noteTags: [],
            isSyncing: false, // Flag to prevent emit during prop sync
        }
    },
    methods: {
        useDefaultHype() {
            this.noteTags.push(this.defaultHype);
        }
    },
    computed: {
        filteredNotes() {
            return this.notes.filter(note => !note.type)
                .map(note => note.text);
        }
    },
    watch: {
        notes: {
            handler() {
                // Update noteTags when notes prop changes
                // Only update if the filtered notes are different to avoid loops
                const newFiltered = this.filteredNotes;
                const currentTags = JSON.stringify([...this.noteTags].sort());
                const newTags = JSON.stringify([...newFiltered].sort());
                if (currentTags !== newTags) {
                    this.isSyncing = true; // Prevent emit during sync
                    this.$nextTick(() => {
                        this.noteTags = [...newFiltered];
                        this.$nextTick(() => {
                            this.isSyncing = false;
                        });
                    });
                }
            },
            deep: true,
        },
        noteDropped(note) {
            let index = this.noteTags.indexOf(note);

            if (index !== -1) {
                this.noteTags.splice(index, 1);
            }
        },
        noteTags(newValue) {
            // Don't emit if we're syncing from prop to avoid infinite loop
            if (this.isSyncing) {
                return;
            }
            // if (newValue.length !== oldValue.length && newValue !== this.filteredNotes) {
            let prepared = newValue.map(note => {
                return { text: note };
            });

            this.$emit('update', prepared);
            // }
        }
    }
}
</script>

<style scoped></style>